const COMMENTS = [
  {
    name: '吃瓜小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20with%20warm%20peach%20background%20gradient%2C%20abstract%20geometric%20design%2C%20flat%20illustration%20style%2C%20clean%20modern%20aesthetic&width=100&height=100&seq=avatar-01&orientation=squarish',
    time: '10分钟前',
    content: '这个瓜真的越吃越大！之前就觉得他俩关系不一般，没想到这么快就被拍到了。坐等后续更多爆料！',
    likes: 1283,
  },
  {
    name: '娱乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20with%20warm%20coral%20background%20gradient%2C%20abstract%20geometric%20design%2C%20flat%20illustration%20style%2C%20clean%20modern%20aesthetic&width=100&height=100&seq=avatar-02&orientation=squarish',
    time: '28分钟前',
    content: '理性吃瓜，等实锤。不过有一说一，这个时间点和之前那个综艺录制前后的互动确实对得上，细节很微妙啊。',
    likes: 876,
  },
  {
    name: '真相挖掘姬',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20with%20warm%20amber%20background%20gradient%2C%20abstract%20geometric%20design%2C%20flat%20illustration%20style%2C%20clean%20modern%20aesthetic&width=100&height=100&seq=avatar-03&orientation=squarish',
    time: '1小时前',
    content: '在每日吃瓜追了快一年了，这里的瓜视频更新速度真的全网最快。早上刚有风吹草动，中午就能看到高清视频，太强了！',
    likes: 2105,
  },
  {
    name: '资深路人甲',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20profile%20avatar%20with%20warm%20pink%20background%20gradient%2C%20abstract%20geometric%20design%2C%20flat%20illustration%20style%2C%20clean%20modern%20aesthetic&width=100&height=100&seq=avatar-04&orientation=squarish',
    time: '2小时前',
    content: '那个税务风波的瓜我追了好几天了，每天都有新进展。每日吃瓜的整理真的很到位，时间线清晰，视频素材也全，点赞！',
    likes: 567,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">瓜友热评</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            百万瓜友的真实声音，看看大家都在讨论哪些大瓜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {COMMENTS.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}